import React, { useCallback, useEffect, useState } from "react";

import { connect } from "react-redux";
import axios from "axios";
import { Link } from "react-router";
import JamezzTableV2, { useReloadState } from "../../components/JamezzTable/V2/JamezzTableV2";
import * as actions from "../../store/actions";

import { apiProviderSupportsFeature } from "../../variables/app";

// @material-ui/core components
import { withStyles } from "tss-react/mui";
import {
  Box,
  Checkbox,
  createTheme,
  FormControlLabel,
  IconButton,
  Switch,
  TableCell,
  TextField,
  ThemeProvider,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";

// material-ui icons
import {
  Add,
  ArrowDownward,
  AssignmentLate,
  AvTimer,
  Delete,
  Edit,
  FreeBreakfast,
  Layers,
  Memory,
  Refresh,
  Schedule,
} from "@mui/icons-material";

// core components
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import Button from "../../components/CustomButtons/Button";

//Modals
import Copy from "./Modals/Copy";
import Pause from "./Modals/Pause";

import productenStyle from "../../assets/jss/material-dashboard-pro-react/views/productStyle";
import MainNavbar from "../../components/Navbars/MainNavbar";

//Filters
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";

import MassEdit from "./Modals/MassEdit";
import CategoryFilter from "../../components/Filters/CategoryFilter";
import TextFilter from "../../components/Filters/TextFilter";
import AuthenticationWrapper from "../../auth/AuthenticationWrapper";
import VestigingFilterV2, { getVestigingFilterStateV2 } from "../../components/VestigingFilter/VestigingFilter";
import AreYouSureDialog from "../../components/Dialogs/AreYouSureDialog";
import { _delete, _post, _request } from "../../http";
import DragAndDrop from "../../hoc/DragAndDrop";
import FormElement from "../../components/JamezzTable/FormElement";
import MenukaartCell from "./Cells/MenukaartCell";
import { ValutaInput } from "../../components/JamezzTable/JamezzTable";
import _ from "lodash";
import { useDialog } from "../../licensing/utils/DialogProvider";
import { DeleteForever, RestoreFromTrash } from "@mui/icons-material";
import { toast } from "react-toastify";
import SalesAreaPriceLineFilter from "../../../../Domains/PriceLines/components/SalesAreaPriceLineFilter";
import ProductPriceLineEditor from "../../../../Domains/PriceLines/components/ProductPriceLineEditor";
import useAskOptimizeImagesDialog from "./useAskForOptimizeImagesDialog";
import { isOpenComingDays } from "@jamezz/react-components";

const jsonEmpty = (data) => {
  try {
    let resData = JSON.parse(data);
    switch (typeof resData) {
      case "object":
        return !Object.keys(resData).length;
      case "array":
        return !resData.length;
    }
  } catch (e) {}
  return true;
};

function Index(props) {
  const { reloadState, updateReloadState } = useReloadState();
  const [openDialog] = useDialog();
  const [priceLineFilterValue, setPriceLineFilterValue] = useState();
  const [showCopyModal, setShowCopyModal] = useState(false);
  const [showPauseModal, setShowPauseModal] = useState(false);
  const [copySingleProductId, setCopySingleProductId] = useState(null);
  const askForOptimizeImages = useAskOptimizeImagesDialog();

  useEffect(() => {
    updateReloadState();
  }, [priceLineFilterValue]);
  const [showMassEditModal, setShowMassEditModal] = useState(false);

  const forceRetryTranslations = useCallback(() => {
    const confirmed = confirm(
      getTranslation(
        "producten.retry.confirm",
        "Are you sure you want to force retry all product translations? This will overwrite existing translations!"
      )
    );

    if (confirmed) {
      axios
        .post("core/producten/forceRetryTranslations", {
          sales_area_id: props.filters?.vestiging_id?.value,
        })
        .then((response) => {
          if (response.data) {
            toast.success(getTranslation("producten.resize.queued", "Translations queued, this may take a while"));
          } else {
            toast.error(getTranslation("producten.resize.failed", "Translations failed!"));
          }
        })
        .catch((err) => {
          toast.error(getTranslation("producten.resize.failed", "Translations failed!"));
        });
    }
  }, [props.filters]);

  const information = useCallback((row) => {
    let icons = [];
    if (!isOpenComingDays(row.opening_hours ?? {}, new Date(), 9)) {
      icons.push(
        <Tooltip
          placement={"bottom"}
          title={
            <>
              <TranslationWrapper tDefault={"Heeft een tijdschema"} tKey={"tooltip.hasTimeTable"} />
              <pre>{JSON.stringify(row.opening_hours, null, 2)}</pre>
            </>
          }
        >
          <AvTimer
            style={{
              fontSize: "125%",
              marginBottom: "-4px",
            }}
          />
        </Tooltip>
      );
    }
    if (row.hideArrangement !== null && row.hideArrangement !== "" && !jsonEmpty(row.hideArrangement)) {
      icons.push(
        <Tooltip
          placement={"bottom"}
          title={<TranslationWrapper tDefault={"Onderdeel van een arrangement"} tKey={"tooltip.belongsToArrangment"} />}
        >
          <AssignmentLate
            style={{
              fontSize: "125%",
              marginBottom: "-4px",
            }}
          />
        </Tooltip>
      );
    }
    if (row.showArrangement !== null && row.showArrangement !== "" && !jsonEmpty(row.showArrangement)) {
      icons.push(
        <Tooltip
          placement={"bottom"}
          title={<TranslationWrapper tDefault={"Onderdeel van een arrangement"} tKey={"tooltip.belongsToArrangment"} />}
        >
          <AssignmentLate
            style={{
              fontSize: "125%",
              marginBottom: "-4px",
            }}
          />
        </Tooltip>
      );
    }
    return <div>{icons}</div>;
  }, []);

  const renderHeaderCells = useCallback(
    () => [
      { id: "id", label: "#", numeric: true, disablePadding: false, sortable: true },

      {
        id: "apiId",
        label: getTranslation("producten.table.apiId", "# API"),
        numeric: false,
        disablePadding: false,
        sortable: false,
      },
      {
        id: "vestiging.naam",
        label: getTranslation("producten.table.vestigingnaam", "Salesarea"),
        numeric: false,
        disablePadding: false,
        sortable: false,
      },
      {
        id: "img",
        label: getTranslation("producten.table.img", "Img"),
        numeric: false,
        disablePadding: false,
        sortable: false,
      },
      {
        id: "naam",
        label: getTranslation("producten.table.naam", "Naam"),
        numeric: false,
        disablePadding: false,
        sortable: true,
      },
      {
        id: "menukaart",
        label: getTranslation("producten.table.menukaart", "Menukaart"),
        numeric: false,
        disablePadding: false,
        sortable: false,
      },
      {
        id: "prijs",
        label: getTranslation("producten.table.prijs", "Prijs"),
        numeric: false,
        disablePadding: false,
        sortable: true,
      },
      {
        id: "is_actief",
        label: getTranslation("producten.table.actief", "Actief"),
        numeric: false,
        disablePadding: false,
        sortable: true,
      },
      {
        id: "blocked",
        label: getTranslation("producten.table.blocked", "blocked"),
        numeric: false,
        disablePadding: false,
        sortable: true,
      },
      {
        id: "not_available",
        label: getTranslation("producten.table.not_available", "not available"),
        numeric: false,
        disablePadding: false,
        sortable: true,
      },
      {
        id: "is_system_product",
        label: getTranslation("producten.table.is_system_product", "System product"),
        disablePadding: false,
      },
      {
        id: "stock",
        label: getTranslation("producten.table.stock", "voorraad"),
        numeric: true,
        disablePadding: false,
        sortable: true,
      },
      {
        id: "sortkey",
        label: getTranslation("global.table.sortkey", "sortkey"),
        numeric: true,
        disablePadding: false,
        sortable: true,
      },
      {
        id: "meta",
        label: getTranslation("global.table.empty", ""),
        numeric: false,
        disablePadding: false,
        sortable: false,
      },
    ],
    []
  );

  const renderRowCells = useCallback(
    (row, isEditable, tableOptions) => {
      let imageUrl = "/img/nophoto.png";
      let imgSrcSet = undefined;
      if (row?.media_urls?.imgid) {
        //als data string is
        if (typeof row?.imgid === "string" && row?.imgid.startsWith("data")) {
          imageUrl = row?.imgid;
        } else if (
          typeof row?.media_urls?.imgid === "object" &&
          Array.isArray(row?.media_urls?.imgid) &&
          row?.media_urls?.imgid?.length > 0
        ) {
          imageUrl =
            row?.media_urls?.imgid?.[0].conversions?.["height_50"]?.url ??
            row?.media_urls?.imgid?.[0].conversions?.["height_200"]?.url ??
            row?.media_urls?.imgid?.[0].original;

          imgSrcSet = row?.media_urls?.imgid?.[0].conversions?.responsive?.srcset;
        }
      }

      return (
        <>
          <TableCell align={"right"} style={{ width: 100, padding: "0 0 0 16px" }}>
            {row.id}
          </TableCell>
          <TableCell style={{ padding: "0 0 0 16px" }}>{row.externalId}</TableCell>
          <TableCell style={{ padding: "0 0 0 16px" }}>{row.vestiging?.naam}</TableCell>
          <TableCell style={{ padding: "0 0 0 16px" }}>
            {isEditable && tableOptions.rowsPerPage <= 100 ? (
              <DragAndDrop
                handleDrop={(file) => {
                  const body = new FormData();
                  body.set("img_uuids__uuid[0]", file[0]);
                  _request("patch", "core/producten/" + row.id, body, {
                    showSpinner: false,
                  }).then(updateReloadState);
                }}
              >
                <div align={"center"} style={{ width: "60px" }}>
                  <img
                    alt={"afbeelding"}
                    sizes={"50px"}
                    src={imageUrl}
                    srcSet={imgSrcSet}
                    style={{ maxWidth: "50px", maxHeight: "50px" }}
                  />
                </div>
              </DragAndDrop>
            ) : (
              <div align={"center"} style={{ width: "60px" }}>
                <img
                  alt={"afbeelding"}
                  sizes={"50px"}
                  src={imageUrl}
                  srcSet={imgSrcSet}
                  style={{ maxWidth: "50px", maxHeight: "50px" }}
                />
              </div>
            )}
          </TableCell>
          <TableCell style={{ padding: "0 0 0 16px" }}>
            <Box sx={{ width: 200 }}>
              {isEditable && tableOptions.rowsPerPage <= 100 ? (
                <FormElement endPoint={"core/producten"} name={"naam"} row={row}>
                  <TextField size={"small"} variant={"outlined"} />
                </FormElement>
              ) : null}
              {!isEditable ? row.naam : null}
              {row.snaam && row.snaam != row.naam && row.vestiging?.apiProvider ? (
                <Typography style={{ fontStyle: "italic", fontSize: "0.8em" }}>POS: {row.snaam}</Typography>
              ) : null}
            </Box>
          </TableCell>
          <TableCell style={{ padding: "0 0 0 16px" }}>
            {row.apiId2 ? (
              <TranslationWrapper
                tDefault={"This is an option/special product"}
                tKey={"This is an option/special product"}
              />
            ) : tableOptions.rowsPerPage <= 100 ? (
              <MenukaartCell isEditable={isEditable} row={row} />
            ) : (
              row.menukaart?.map((menukaart, index) => {
                const lastIndex = row.menukaart.length - 1 === index;
                if (lastIndex) {
                  return menukaart.naam;
                } else {
                  return menukaart.naam + " | ";
                }
              })
            )}
          </TableCell>
          <TableCell style={{ padding: "0 0 0 16px", width: 60 }}>
            {!apiProviderSupportsFeature(row.vestiging?.apiProvider, "editProductPrice") || !isEditable ? (
              <Tooltip
                title={
                  <TranslationWrapper
                    tDefault={"This can only be changed inside the POS system"}
                    tKey={"product.is_actief.explanation"}
                  />
                }
              >
                <TextField disabled={true} value={row.prijs} />
              </Tooltip>
            ) : priceLineFilterValue ? (
              <ProductPriceLineEditor
                currency={row.valuta}
                productId={row.id}
                productPriceLines={row.product_price_lines}
                salesAreaPriceLine={priceLineFilterValue}
              />
            ) : !apiProviderSupportsFeature(row.vestiging?.apiProvider, "editProductPrice") ||
              !isEditable ||
              tableOptions.rowsPerPage > 100 ? (
              <Typography>{row.prijs}</Typography>
            ) : (
              <FormElement
                askForConfirmation={true}
                endPoint={"core/producten"}
                inputProps={{
                  style: { paddingTop: "6px", width: "60px" },
                }}
                name={"prijs"}
                parseOnChange={(o) => {
                  return o.value;
                }}
                row={row}
                showLoadingSpinner={false}
              >
                <ValutaInput
                  currency={row.valuta ?? "EUR"}
                  disabled={
                    !apiProviderSupportsFeature(row.vestiging?.apiProvider, "editProductPrice") ||
                    !isEditable ||
                    tableOptions.rowsPerPage > 100
                  }
                  name={"prijs"}
                  propKey={row.id}
                  value={row.prijs}
                />
              </FormElement>
            )}

            {/*<FormElement*/}
            {/*  name={"prijs"}*/}
            {/*  row={row}*/}
            {/*  endPoint={"core/producten"}*/}
            {/*  parseOnChange={(e) => e.value}*/}
            {/*  askForConfirmation={false}*/}
            {/*  showLoadingSpinner={false}*/}
            {/*>*/}
            {/*  <ValutaInput*/}
            {/*    propKey={row.id}*/}
            {/*    value={row.prijs}*/}
            {/*    name={"prijs"}*/}
            {/*    currency={row.valuta ?? "EUR"}*/}
            {/*    disabled={*/}
            {/*      !apiProviderSupportsFeature(row.vestiging?.apiProvider, "editProductPrice") ||*/}
            {/*      !isEditable ||*/}
            {/*      tableOptions.rowsPerPage > 100*/}
            {/*    }*/}
            {/*  />*/}
            {/*</FormElement>*/}
          </TableCell>
          <TableCell style={{ padding: "0 0 0 16px" }}>
            {tableOptions.rowsPerPage <= 100 ? (
              !apiProviderSupportsFeature(row.vestiging?.apiProvider, "editProductActive") || !isEditable ? (
                <Tooltip
                  title={
                    <TranslationWrapper
                      tDefault={"This can only be changed inside the POS system"}
                      tKey={"product.is_actief.explanation"}
                    />
                  }
                >
                  <Checkbox checked={row.is_actief} disabled={true} />
                </Tooltip>
              ) : (
                <FormElement
                  askForConfirmation={false}
                  endPoint={"core/producten"}
                  name={"is_actief"}
                  parseBoolToInt={true}
                  row={row}
                  showLoadingSpinner={false}
                  valueKey={"checked"}
                >
                  <Checkbox color={"primary"} />
                </FormElement>
              )
            ) : row.is_actief ? (
              <TranslationWrapper tDefault={"Yes"} tKey={"Yes"} />
            ) : (
              <TranslationWrapper tDefault={"No"} tKey={"No"} />
            )}
          </TableCell>
          <TableCell style={{ padding: "0 0 0 16px" }}>
            {tableOptions.rowsPerPage <= 100 ? (
              isEditable && (
                <FormElement
                  askForConfirmation={false}
                  endPoint={"core/producten"}
                  name={"blocked"}
                  parseBoolToInt={true}
                  row={row}
                  showLoadingSpinner={false}
                  valueKey={"checked"}
                >
                  <Switch color={"primary"} disabled={!isEditable} />
                </FormElement>
              )
            ) : row.blocked ? (
              <TranslationWrapper tDefault={"Yes"} tKey={"Yes"} />
            ) : (
              <TranslationWrapper tDefault={"No"} tKey={"No"} />
            )}
          </TableCell>
          <TableCell style={{ padding: "0 0 0 16px" }}>
            {tableOptions.rowsPerPage <= 100 ? (
              isEditable && (
                <FormElement
                  askForConfirmation={false}
                  endPoint={"core/producten"}
                  name={"not_available"}
                  parseBoolToInt={true}
                  row={row}
                  showLoadingSpinner={false}
                  valueKey={"checked"}
                >
                  <Switch color={"primary"} disabled={!isEditable} />
                </FormElement>
              )
            ) : row.blocked ? (
              <TranslationWrapper tDefault={"Yes"} tKey={"Yes"} />
            ) : (
              <TranslationWrapper tDefault={"No"} tKey={"No"} />
            )}
          </TableCell>
          <TableCell style={{ padding: "0 0 0 16px" }}>
            <Tooltip title={row.system_product_variant}>
              <span>{row.is_system_product ? "yes" : "no"}</span>
            </Tooltip>
          </TableCell>
          <TableCell style={{ padding: "0 0 0 16px" }}>
            {tableOptions.rowsPerPage > 100 ? (
              row.stock
            ) : (
              <FormElement endPoint={"core/producten"} name={"stock"} row={row}>
                <TextField size={"small"} style={{ width: 60 }} type={"number"} variant={"outlined"} />
              </FormElement>
            )}
          </TableCell>
          <TableCell style={{ padding: "0 0 0 16px" }}>
            {tableOptions.rowsPerPage > 100 ? (
              row.sortkey
            ) : (
              <FormElement endPoint={"core/producten"} name={"sortkey"} row={row}>
                <TextField size={"small"} style={{ width: 60 }} type={"number"} variant={"outlined"} />
              </FormElement>
            )}
          </TableCell>
          <TableCell style={{ padding: "0 0 0 16px" }}>
            {tableOptions.rowsPerPage <= 100 ? information(row) : null}
          </TableCell>
        </>
      );
    },
    [priceLineFilterValue]
  );

  const renderRowActions = useCallback((row, tableOptions) => {
    const editLink = `./${row.id}/edit`;
    return (
      <TableCell align={"right"} style={{ padding: "0 0 0 16px" }}>
        {!tableOptions.showArchive ? (
          <>
            <Tooltip title={<TranslationWrapper tDefault={"Duplicate"} tKey={"producten.dupliceer.1item"} />}>
              <Button
                className={classes.actionButton}
                color={"success"}
                onClick={() => {
                  setCopySingleProductId(row.id);
                }}
                simple
                style={{ padding: "2px 5px 2px 5px" }}
              >
                <Layers className={classes.icon} />
              </Button>
            </Tooltip>

            <AuthenticationWrapper permissionKey={"producten/:id/edit"}>
              <Link to={editLink}>
                <Tooltip
                  classes={{ tooltip: classes.tooltip }}
                  placement={"bottom"}
                  title={<TranslationWrapper tDefault={"Edit"} tKey={"global.jamezzTable.edit.product"} />}
                >
                  <Button
                    className={classes.actionButton}
                    color={"success"}
                    simple
                    style={{ padding: "2px 5px 2px 5px" }}
                  >
                    <Edit className={classes.icon} />
                  </Button>
                </Tooltip>
              </Link>
            </AuthenticationWrapper>
          </>
        ) : null}
        <AuthenticationWrapper permissionKey={"producten.delete"}>
          {tableOptions.showArchive ? (
            <Tooltip
              classes={{ tooltip: classes.tooltip }}
              placement={"bottom"}
              title={<TranslationWrapper tDefault={"Herstel"} tKey={"global.jamezzTable.restore"} />}
            >
              <Button
                className={classes.actionButton}
                color={"success"}
                onClick={() => {
                  openDialog({
                    children: (
                      <AreYouSureDialog
                        content={
                          <TranslationWrapper
                            tDefault={"Restore? Are you sure you want to restore this item?"}
                            tKey={"global.jamezztable.confirm.restore.product"}
                          />
                        }
                        onOk={() => {
                          _post(`/core/producten/${row.id}/restore`).finally(updateReloadState);
                        }}
                      />
                    ),
                  });
                }}
                simple
                style={{ padding: "2px 5px 2px 5px" }}
              >
                <RestoreFromTrash className={classes.icon} />
              </Button>
            </Tooltip>
          ) : row.is_archivable || row.vestiging?.apiProvider == "JAMEZZ" || row.vestiging?.apiProvider == null ? (
            <Tooltip
              classes={{ tooltip: classes.tooltip }}
              placement={"bottom"}
              title={<TranslationWrapper tDefault={"Verwijderen"} tKey={"global.jamezzTable.remove"} />}
            >
              <Button
                className={classes.actionButton}
                color={"danger"}
                onClick={() => {
                  openDialog({
                    children: (
                      <AreYouSureDialog
                        content={
                          <TranslationWrapper
                            tDefault={"Delete? Are you sure you want to delete this item?"}
                            tKey={"global.jamezztable.confirm.delete.product"}
                          />
                        }
                        onOk={() => {
                          _delete("/core/producten/" + row.id).finally(updateReloadState);
                        }}
                      />
                    ),
                  });
                }}
                simple
                style={{ padding: "2px 5px 2px 5px" }}
              >
                <Delete className={classes.icon} />
              </Button>
            </Tooltip>
          ) : (
            <></>
          )}
        </AuthenticationWrapper>
      </TableCell>
    );
  }, []);

  const renderSelectionActions = useCallback(
    (selected, tableOptions) => {
      return (
        <>
          {showCopyModal ? (
            <Copy
              open={showCopyModal}
              productIds={selected}
              refreshTable={updateReloadState}
              toggle={() => setShowCopyModal((val) => !val)}
            />
          ) : null}
          {showPauseModal ? (
            <Pause
              open={showPauseModal}
              productIds={selected}
              refreshTable={updateReloadState}
              toggle={() => setShowPauseModal((val) => !val)}
            />
          ) : null}
          {showMassEditModal ? (
            <MassEdit
              open={showMassEditModal}
              productIds={selected}
              refreshTable={updateReloadState}
              toggle={() => setShowMassEditModal((val) => !val)}
            />
          ) : null}
          {selected.length > 0 && tableOptions.showArchive === false ? (
            <Tooltip title={<TranslationWrapper tDefault={"Optimize images"} tKey={"optimize-images"} />}>
              <IconButton
                className={classes.marginRight}
                color={"success"}
                onClick={() =>
                  askForOptimizeImages(selected).then(() => {
                    this.refreshJamezzTable();
                  })
                }
                style={{ color: "lightgreen" }}
              >
                <Memory className={classes.icons} />
              </IconButton>
            </Tooltip>
          ) : null}

          {selected.length > 0 && tableOptions.showArchive === false ? (
            <Tooltip title={<TranslationWrapper tDefault={"Dupliceer producten"} tKey={"producten.dupliceer.item"} />}>
              <IconButton
                className={classes.marginRight}
                color={"success"}
                onClick={() => setShowCopyModal(true)}
                style={{ color: "lightgreen" }}
              >
                <Layers className={classes.icons} />
              </IconButton>
            </Tooltip>
          ) : null}
          {selected.length > 0 && tableOptions.showArchive === false ? (
            <Tooltip title={<TranslationWrapper tDefault={"Edit"} tKey={"producten.massEdit"} />}>
              <IconButton className={classes.marginRight} color={"success"} onClick={() => setShowMassEditModal(true)}>
                <Edit className={classes.icons} />
              </IconButton>
            </Tooltip>
          ) : null}
          <Tooltip title={<TranslationWrapper tKey={"Pause"} />}>
            <IconButton
              className={classes.marginRight}
              onClick={() => {
                setShowPauseModal(true);
              }}
              style={{ color: "turquoise" }}
            >
              <Schedule />
            </IconButton>
          </Tooltip>
          {tableOptions.showArchive === false ? (
            <AuthenticationWrapper permissionKey={"producten.delete"}>
              <Tooltip title={<TranslationWrapper tKey={"Delete"} />}>
                <IconButton
                  className={classes.marginRight}
                  onClick={() => {
                    openDialog({
                      children: (
                        <AreYouSureDialog
                          content={selected.length + " item(s)"}
                          onOk={() => {
                            _post(
                              "/core/producten/multipledelete",
                              { ids: selected },
                              {
                                showToastError: true,
                              }
                            ).then(() => {
                              updateReloadState();
                            });
                          }}
                        />
                      ),
                    });
                  }}
                  style={{ color: "lightcoral" }}
                >
                  <Delete />
                </IconButton>
              </Tooltip>
            </AuthenticationWrapper>
          ) : null}

          <AuthenticationWrapper permissionKey={"producten.move.to.delete"}>
            <Tooltip title={<TranslationWrapper tKey={"Move to delete area"} />}>
              <IconButton
                className={classes.marginRight}
                onClick={() => {
                  openDialog({
                    children: (
                      <AreYouSureDialog
                        content={
                          getTranslation(
                            "Attention: This will move the product either to or from the delete sales area."
                          ) +
                          " | " +
                          selected.length +
                          getTranslation(" item(s) selected")
                        }
                        onOk={() => {
                          _post("/core/producten/moveDelete", { ids: selected }).then(updateReloadState);
                        }}
                      />
                    ),
                  });
                }}
                style={{ color: "black" }}
              >
                <DeleteForever />
              </IconButton>
            </Tooltip>
          </AuthenticationWrapper>
        </>
      );
    },
    [showCopyModal, showMassEditModal, showPauseModal]
  );

  const { classes } = props;

  const origTheme = useTheme();

  const theme = createTheme(
    _.merge(
      {
        overrides: {
          // Style sheet name ⚛️
          MuiTableCell: {
            // Name of the rule
            sizeSmall: {
              // Some CSS
              padding: "2px",
            },
          },
        },
      },
      origTheme
    )
  );

  if (
    // props.filters?.vestiging_id &&
    props.filters?.["producten:name"] &&
    props.filters?.vestiging_id?.value == null &&
    props.filters?.["vestiging.venue_id"]?.value == null
  ) {
    props.setFilter("producten:name", null);
  }

  return (
    <div>
      <MainNavbar paginaTitel={<TranslationWrapper tDefault={"Producten overzicht"} tKey={"producten.pagetitle"} />} />
      <GridContainer>
        <GridItem>
          {props.filters?.vestiging_id?.value ? (
            <div style={{ display: "flex", flexWrap: "wrap", padding: "8px 0px 8px 0px" }}>
              <AuthenticationWrapper permissionKey={"producten.create"}>
                <Link to={"./create"}>
                  <Button className={classes.marginRight} color={"success"}>
                    <Add className={classes.icons} />
                    <TranslationWrapper tDefault={"Nieuw product"} tKey={"producten.nieuw.item"} />
                  </Button>
                </Link>
                <Link to={"./import"}>
                  <Button className={classes.marginRight} color={"success"}>
                    <ArrowDownward className={classes.icons} />
                    <TranslationWrapper tDefault={"Importeer"} tKey={"producten.importeer.item"} />
                  </Button>
                </Link>
              </AuthenticationWrapper>

              <AuthenticationWrapper permissionKey={"producten.translate.force"}>
                <Button className={classes.marginRight} color={"danger"} onClick={forceRetryTranslations}>
                  <Refresh className={classes.icons} />
                  <TranslationWrapper tDefault={"Force retry translations"} tKey={"producten.translate.force"} />
                </Button>
              </AuthenticationWrapper>
            </div>
          ) : null}
        </GridItem>
      </GridContainer>

      <GridContainer>
        <VestigingFilterV2 useMenukaartReferences={true} />
        <GridItem sm={4} xs={12}>
          <CategoryFilter />
        </GridItem>

        <GridItem md={4} xs={12}>
          <TextFilter
            disabled={Object.keys(props.filters).length === 0}
            extraFilterKeyValuePairs={{
              vestiging_id: props.filters?.vestiging_id?.value,
              venue_id: props.filters?.["vestiging.venue_id"]?.value,
            }}
            field={["naam", "apiId1", "id"]}
            fieldKey={"producten:name"}
            operator={"like"}
            placeholder={getTranslation("producten.filter.product", "Filter op product")}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={props["systemProducts"]}
                color={"primary"}
                onChange={(e) => {
                  if (e.target.checked) {
                    props.setFilter("systemProducts", {
                      field: "is_system_product",
                      operator: "=",
                      value: true,
                      label: getTranslation(
                        "categories.filter.checkbox.onlyShowSystemProducts",
                        "Only show system products"
                      ),
                      vestiging_id: props.vestiging_id?.value,
                    });
                  } else {
                    props.setFilter("systemProducts", null);
                  }
                }}
              />
            }
            label={getTranslation("categories.filters.checkbox.onlyShowSystemProducts", "Only show system products")}
          />
        </GridItem>
      </GridContainer>
      <SalesAreaPriceLineFilter onChange={(value) => setPriceLineFilterValue(value)} value={priceLineFilterValue} />

      <GridContainer>
        <GridItem xs={12}>
          <ThemeProvider theme={theme}>
            <JamezzTableV2
              checkboxSelection={true}
              delete={"producten.delete"}
              dense={true}
              endPoint={"core/producten"}
              filters={props.filters}
              headerIcon={<FreeBreakfast />}
              reloadState={reloadState}
              renderCellsForRow={renderRowCells}
              renderHeaderCells={renderHeaderCells}
              renderRowActions={renderRowActions}
              renderSelectionActions={renderSelectionActions}
              showRefresh={true}
              tableTitle={<TranslationWrapper tDefault={"Producten"} tKey={"producten.table.titel"} />}
              uuid={"Product-asjdlkjk"}
            />
          </ThemeProvider>
        </GridItem>
      </GridContainer>

      {/*POPUPS*/}
      {copySingleProductId ? (
        <Copy
          open={!!copySingleProductId}
          productIds={[copySingleProductId]}
          refreshTable={updateReloadState}
          toggle={() => setCopySingleProductId(null)}
        />
      ) : null}
    </div>
  );
}

//REDUX
const mapStateToProps = (state) => {
  const filters = getVestigingFilterStateV2(state, true);

  if (state.filtersV2["menukaart.id"]) {
    filters["menukaart.id"] = state.filtersV2["menukaart.id"];
  }
  if (state.filtersV2["producten:name"]) {
    filters["producten:name"] = state.filtersV2["producten:name"];
  }
  if (state.filtersV2["systemProducts"]) {
    filters["systemProducts"] = state.filtersV2["systemProducts"];
  }

  return {
    filters,
    vestiging_id: state.filtersV2.vestiging_id?.value,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
    closeMessage: () => dispatch({ type: actions.CLOSE_MESSAGE }),
    setFilter: (key, filter) => {
      dispatch({
        type: actions.SET_FILTER,
        payload: { key, filter },
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(Index, productenStyle));
